export var KEYCODE_ENTER = 13;
export var KEYCODE_ESC = 27;
export var KEYCODE_SPACEBAR = 32;